
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/developments",
      function () {
        return require("private-next-pages/developments.page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/developments"])
      });
    }
  